import React from 'react';

import { Container, Section } from 'components';

import { PackageDetails } from './PackageDetails';

export const PackageDetailsPage = () => (
  <Container>
    <Section>
      <PackageDetails />
    </Section>
  </Container>
);
